export const linkdata = [
    {
        heading: "Find me here:",
        links: [
            {
                id: 1,
                image: "/assets/links/instagram.webp",
                title: "Instagram",
                description: "Follow my instagram page to learn about UI/UX Design and Web Development.",
                link: "https://www.instagram.com/devrajchatribin/",
            },
            {
                id: 2,
                image: "/assets/links/linkedin.webp",
                title: "LinkedIn",
                description: "Let's connect on LinkedIn and stay in touch!",
                link: "https://www.linkedin.com/in/devraj-chatribin/",
            },
            {
                id: 3,
                image: "/assets/links/discord.webp",
                title: "Discord (Design & Code)",
                description: "Join my community on discord to learn about Design and Development.",
                link: "https://discord.gg/gM3bG4rAU5",
            },
            {
                id: 4,
                image: "/assets/links/github.webp",
                title: "GitHub",
                description: "Follow me on GitHub to get access to my projects source code.",
                link: "https://github.com/DevrajDC",
            },
            {
                id: 5,
                image: "/assets/links/twitter.webp",
                title: "Twitter",
                description: "Follow me on Twitter to see more of my content.",
                link: "https://twitter.com/devrajchatribin",
            },
            {
                id: 6,
                image: "/assets/links/youtube.webp",
                title: "YouTube",
                description: "Subscribe to learn from the Industry experts and mentors.",
                link: "https://www.youtube.com/c/DesignandCodeCommunity?sub_confirmation=1",
            },
            {
                id: 7,
                image: "/assets/links/behance.webp",
                title: "Behance",
                description: "Check out my designs on my Behance page.",
                link: "https://www.behance.net/devrajchatribin",
            },
            {
                id: 8,
                image: "/assets/links/codepen.webp",
                title: "Codepen",
                description: "Check out pens on codepen & use them in your projects.",
                link: "https://codepen.io/devrajdc",
            },
            {
                id: 9,
                image: "/assets/links/figma.webp",
                title: "Figma",
                description: "High-quality resources and tools which can be used in daily work.",
                link: "http://figma.com/@devrajchatribin",
            },
            {
                id: 10,
                image: "/assets/links/dribbble.webp",
                title: "Dribbble",
                description: "Checkout my designs on my Dribbble account.",
                link: "https://dribbble.com/devrajchatribin",
            },
        ]
    },
    {
        heading: "Support my work:",
        links: [
            {
                id: 1,
                image: "/assets/links/buymeacoffee.webp",
                title: "Buy me a Coffee",
                description: "Support me and my work by donating me. Even a smallest amount is appreciated and can help me a lot!",
                link: "https://www.buymeacoffee.com/devrajchatribin",
            },
            {
                id: 2,
                image: "/assets/links/github.webp",
                title: "GitHub Sponsors",
                description: "Support me and my work by donating me. Even a smallest amount is appreciated and can help me a lot!",
                link: "https://github.com/sponsors/DevrajDC",
            },
            {
                id: 3,
                image: "/assets/links/paypal.webp",
                title: "Paypal",
                description: "Support me and my work by donating me. Even a smallest amount is appreciated and can help me a lot!",
                link: "https://www.paypal.com/paypalme/devrajchatribin",
            },
            {
                id: 4,
                image: "/assets/links/kofi.webp",
                title: "Ko-Fi",
                description: "Support me and my work by donating me. Even a smallest amount is appreciated and can help me a lot!",
                link: "https://ko-fi.com/devrajchatribin",
            },
        ]
    },
    {
        heading: "Freebies for you:",
        links: [
            {
                id: 1,
                image: "https://dev-to-uploads.s3.amazonaws.com/uploads/articles/xp34p3vii42rhx3m7zsh.gif",
                title: "GSAP Page Transitions",
                description: "Smooth page transition using BarbaJS and GSAP.",
                link: "https://github.com/DevrajDC/page-transition-v2",
            },
            {
                id: 2,
                image: "https://dev-to-uploads.s3.amazonaws.com/uploads/articles/wta93riog0r7zgqp7rrn.gif",
                title: "React Cursors",
                description: "Smooth cursor with transition effects for your ReactJS Projects.",
                link: "https://www.npmjs.com/package/react-cursors",
            },
            {
                id: 3,
                image: "https://dev-to-uploads.s3.amazonaws.com/uploads/articles/8iyqaljua3735v7mvokq.gif",
                title: "GSAP Page Transitions",
                description: "Smooth page transition using BarbaJS and GSAP.",
                link: "https://github.com/DevrajDC/page-transition-v1",
            },
            {
                id: 4,
                image: "https://dev-to-uploads.s3.amazonaws.com/uploads/articles/mi3qh1po9eby0ud3krkf.gif",
                title: "Page Reveal Animation",
                description: "Stroke logo preloader/ page reveal animation using GSAP.",
                link: "https://github.com/DevrajDC/page-reveal-transitions",
            },
            {
                id: 5,
                image: "https://dev-to-uploads.s3.amazonaws.com/uploads/articles/yrakbgnyxitkaqzh0qs9.png",
                title: "Resources Hub",
                description: "High-quality resources and tools which can be used in daily work.",
                link: "https://github.com/DevrajDC/resourceshub",
            },
        ]
    }
];
